module.exports = __webpack_public_path__ + "img/flows.a3a53e2c.png";